import { render, staticRenderFns } from "./DialogSolicitudNivelacion.vue?vue&type=template&id=e4794164&scoped=true"
import script from "./DialogSolicitudNivelacion.vue?vue&type=script&lang=js"
export * from "./DialogSolicitudNivelacion.vue?vue&type=script&lang=js"
import style0 from "./DialogSolicitudNivelacion.vue?vue&type=style&index=0&id=e4794164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4794164",
  null
  
)

export default component.exports